export * from './getValueFormEvent'

export const isNative = typeof navigator != 'undefined' && navigator.product == 'ReactNative'
